import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamZHTW() {
  return (
    <div className={styles["declaration"]}>
      <h1>關於渠道零售人員培訓考試的合規聲明</h1>

      <p>
        為持續提升一線第三方促銷員的服務質量，小米國際部培訓團隊（以下簡稱「我司」）為外包服務商選派的一線第三方促銷員（以下簡稱「學員」）提供培訓課程及配套的知識鞏固考試，旨在優化課程內容、鞏固學習成果，不構成任何形式的勞動關系或實際管理行為。現就培訓考試事項聲明如下：
      </p>

      <ol>
        <li>
          <strong>培訓考試性質說明</strong><br/>
          所有培訓課程及考試均基於知識共享目的開展，旨在幫助學員系統性掌握產品信息、服務規範等。考試結果僅反映學員對當次培訓內容的掌握情況，不作為績效評估依據，我司無權且不會幹預外包服務商對學員的績效考核、薪酬分配或其他勞動關系事項。
        </li>
        <li>
          <strong>法律關系澄清</strong><br/>
          學員與所屬外包服務商之間的勞動關系不受本培訓考試項目影響。我司與學員之間不存在勞動關系，也不因知識共享性質的培訓考試與學員產生任何事實雇傭關系。
        </li>
        <li>
          <strong>考試結果用途</strong><br/>
          考試結果僅限於以下用途：
          <ol type="1">
            <li>作為我司內部課程優化改進的參考依據；</li>
            <li>基於外包服務商的自主判斷與意願，可提供給外包服務商作為學員專業水平的證明，作為能力參考；</li>
            <li>考試結果不會公開，亦不會向第三方披露。</li>
          </ol>
        </li>
      </ol>

      <p>
        本聲明自發布之日起生效，學員參與培訓考試項目即視為已閱讀並同意本聲明內容。我司保留對本聲明的最終解釋權及合理修訂權。
      </p>

      <div className={styles["footer"]}>
        小米國際部培訓團隊<br/>
        日期：{getLocalizedTime('zh-TW')}
      </div>
    </div>
  );
}